class BhmEmbla {
  constructor(container) {
    this.container = typeof container === 'string'
      ? document.querySelector(container)
      : container;
    this.emblaInstance = null;
  }

  updateNavButtons() {
    if (!this.emblaInstance) return;

    const prevBtn = this.container.querySelector('.embla__prev');
    const nextBtn = this.container.querySelector('.embla__next');

    if (!prevBtn || !nextBtn) return;

    prevBtn.disabled = !this.emblaInstance.canScrollPrev();
    nextBtn.disabled = !this.emblaInstance.canScrollNext();
  }

  initEmbla() {
    const viewport = this.container.querySelector('.embla__viewport');

    if (!viewport) return;

    if (window.innerWidth >= 768 && !this.emblaInstance) {
      this.emblaInstance = EmblaCarousel(viewport, {
        loop: false,
        align: 'start',
        dragFree: false
      });

      this.emblaInstance.on('select', () => this.updateNavButtons());
      this.emblaInstance.on('init', () => this.updateNavButtons());
      this.emblaInstance.on('reInit', () => this.updateNavButtons());

      this.addNav();
    }

    if (window.innerWidth < 768 && this.emblaInstance) {
      this.emblaInstance.destroy();
      this.emblaInstance = null;
    }
  }

  addNav() {
    this.container.querySelector('.embla__prev')?.addEventListener('click', () => {
      this.emblaInstance?.scrollPrev();
    });

    this.container.querySelector('.embla__next')?.addEventListener('click', () => {
      this.emblaInstance?.scrollNext();
    });
  }

  init() {
    window.addEventListener('load', () => this.initEmbla());
    window.addEventListener('resize', () => this.initEmbla());
    document.addEventListener('shopify:section:load', () => this.initEmbla());
  }
}

class BhmVideoOverlay {
  constructor(sources, poster) {
    document.querySelectorAll('.video-overlay').forEach((videoOverlay) => videoOverlay.remove());

    const overlay = document.createElement('DIV');
    overlay.classList.add('video-overlay');
    overlay.classList.add('is-visible');
    overlay.classList.add('is-playing');

    const html = `<video
      width="${sources[0].width}"
      height="${sources[0].height}"
      loop
      playsinline
      preload="auto"
      poster="${poster}"
    >
      ${sources.map((source) => {
        return `<source src="${source.src}" type="${source.type}" />`
      })}
    </video>

    <svg class="video-overlay-close" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="14.4444" y1="0.707107" x2="2.12118" y2="13.0303" stroke="white" stroke-width="2"/>
      <line y1="-1" x2="17.4277" y2="-1" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1.41406 0)" stroke="white" stroke-width="2"/>
    </svg>

    <svg class="video-overlay-play" width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.9347 32.6214C42.5193 30.1758 37.1 33.3692 37.1 38.4169V67.5835C37.1 72.6312 42.5193 75.8245 46.9347 73.379L77.451 56.4773C78.7156 55.7772 79.5 54.4453 79.5 53C79.5 51.5547 78.7156 50.2233 77.451 49.5227L46.9347 32.6214ZM53 0C23.7289 0 0 23.7289 0 53C0 82.2708 23.7289 106 53 106C82.2708 106 106 82.2708 106 53C106 23.7289 82.2708 0 53 0ZM7.95 53C7.95 28.1196 28.1196 7.95 53 7.95C77.8803 7.95 98.05 28.1196 98.05 53C98.05 77.8803 77.8803 98.05 53 98.05C28.1196 98.05 7.95 77.8803 7.95 53Z" fill="white"/>
    </svg>`;

    overlay.innerHTML = html;

    document.body.appendChild(overlay);

    const close = overlay.querySelector('.video-overlay-close');
    const video = overlay.querySelector('video');

    video.play();

    close.addEventListener('click', (event) => {
      event.stopPropagation();
      overlay.remove();
    });

    overlay.addEventListener('click', () => {
      overlay.classList.toggle('is-playing');

      if (overlay.classList.contains('is-playing')) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
}

class BhmReelOverlay {
  constructor(container, sources, poster) {
    if (container.querySelector('.video-overlay')) {
      return;
    }

    document.querySelectorAll('.video-overlay').forEach((videoOverlay) => videoOverlay.remove());

    const overlay = document.createElement('DIV');
    overlay.classList.add('video-overlay');
    overlay.classList.add('is-visible');
    overlay.classList.add('is-playing');

    const html = `<video
      width="${sources[0].width}"
      height="${sources[0].height}"
      loop
      playsinline
      preload="auto"
      poster="${poster}"
    >
      ${sources.map((source) => {
        return `<source src="${source.src}" type="${source.type}" />`
      })}
    </video>

    <svg class="video-overlay-play" width="106" height="106" viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M46.9347 32.6214C42.5193 30.1758 37.1 33.3692 37.1 38.4169V67.5835C37.1 72.6312 42.5193 75.8245 46.9347 73.379L77.451 56.4773C78.7156 55.7772 79.5 54.4453 79.5 53C79.5 51.5547 78.7156 50.2233 77.451 49.5227L46.9347 32.6214ZM53 0C23.7289 0 0 23.7289 0 53C0 82.2708 23.7289 106 53 106C82.2708 106 106 82.2708 106 53C106 23.7289 82.2708 0 53 0ZM7.95 53C7.95 28.1196 28.1196 7.95 53 7.95C77.8803 7.95 98.05 28.1196 98.05 53C98.05 77.8803 77.8803 98.05 53 98.05C28.1196 98.05 7.95 77.8803 7.95 53Z" fill="white"/>
    </svg>`;

    overlay.innerHTML = html;

    container.appendChild(overlay);

    const video = overlay.querySelector('video');

    video.play();

    overlay.addEventListener('click', () => {
      overlay.classList.toggle('is-playing');

      if (overlay.classList.contains('is-playing')) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
}
